/**
 * HUNA.PK — High-Scale Direct Response Flagship Landing Page JS
 * Scoped Namespace: HunaLanding
 * Zero External Dependencies (< 12KB unminified)
 */

(function () {
  'use strict';

  // 1. Root Isolation Initialization
  if (document.documentElement && !document.documentElement.classList.contains('huna-landing-active')) {
    document.documentElement.classList.add('huna-landing-active');
  }

  // 2. Interactive 4-in-1 Lens Switcher
  function initLensSwitcher() {
    var tabs = document.querySelectorAll('[data-huna-tab]');
    var panels = document.querySelectorAll('[data-huna-panel]');
    if (!tabs.length || !panels.length) return;

    function activateTab(targetIndex) {
      tabs.forEach(function (tab, i) {
        var isTarget = i === targetIndex;
        tab.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        tab.classList.toggle('is-active', isTarget);
      });

      panels.forEach(function (panel, i) {
        var isTarget = i === targetIndex;
        panel.classList.toggle('is-active', isTarget);
        panel.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(index);
      });

      tab.addEventListener('keydown', function (e) {
        var newIndex = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          newIndex = (index + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          newIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
          newIndex = 0;
        } else if (e.key === 'End') {
          newIndex = tabs.length - 1;
        }

        if (newIndex !== -1) {
          e.preventDefault();
          tabs[newIndex].focus();
          activateTab(newIndex);
        }
      });
    });
  }

  // 3. Mobile Sticky Purchase Bar Visibility
  function initStickyBar() {
    var stickyBar = document.getElementById('huna-lp-sticky-bar');
    var heroCta = document.getElementById('huna-lp-hero-cta');
    var offerSection = document.getElementById('huna-offer');
    if (!stickyBar || !heroCta) return;

    var heroPassed = false;
    var inOffer = false;

    function updateStickyVisibility() {
      if (heroPassed && !inOffer) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    if ('IntersectionObserver' in window) {
      var heroObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          heroPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateStickyVisibility();
        });
      }, { threshold: 0 });

      heroObserver.observe(heroCta);

      if (offerSection) {
        var offerObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inOffer = entry.isIntersecting;
            updateStickyVisibility();
          });
        }, { threshold: 0.1 });

        offerObserver.observe(offerSection);
      }
    } else {
      // Fallback for browsers without IntersectionObserver
      window.addEventListener('scroll', function () {
        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollY > 500) {
          stickyBar.classList.add('is-visible');
        } else {
          stickyBar.classList.remove('is-visible');
        }
      }, { passive: true });
    }
  }

  // 4. Native Purchase Action with Single-Flight Protection
  function initPurchaseAction() {
    var orderForm = document.getElementById('huna-lp-order-form');
    var heroForm = document.getElementById('huna-lp-hero-form');

    function bindFormSubmit(form) {
      if (!form) return;

      var submitBtn = form.querySelector('[data-huna-action="add-to-cart"]');
      var errorEl = form.querySelector('[data-huna-error]');
      var isSubmitting = false;

      form.addEventListener('submit', function (e) {
        // Prevent submission if already in flight
        if (isSubmitting) {
          e.preventDefault();
          return;
        }

        var variantIdInput = form.querySelector('input[name="id"]');
        var variantId = variantIdInput ? variantIdInput.value : '';

        if (!variantId || variantId === '1' || variantId === '') {
          if (errorEl) {
            errorEl.textContent = 'Please select a valid product option.';
            errorEl.hidden = false;
          }
          e.preventDefault();
          return;
        }

        // If fetch is available, perform smooth AJAX add + redirect to checkout
        if ('fetch' in window && 'FormData' in window) {
          e.preventDefault();
          isSubmitting = true;

          if (submitBtn) {
            submitBtn.setAttribute('aria-busy', 'true');
            submitBtn.disabled = true;
          }

          var formData = new FormData(form);

          fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
            headers: {
              'Accept': 'application/json'
            }
          })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw err;
              });
            }
            return res.json();
          })
          .then(function () {
            // Navigate cleanly to native Shopify 1-page checkout
            window.location.href = '/checkout';
          })
          .catch(function (err) {
            isSubmitting = false;
            if (submitBtn) {
              submitBtn.removeAttribute('aria-busy');
              submitBtn.disabled = false;
            }
            if (errorEl) {
              var message = (err && err.description) ? err.description : 'Unable to proceed to checkout. Please try again.';
              errorEl.textContent = message;
              errorEl.hidden = false;
            }
          });
        }
        // Fallback: If fetch is unsupported, standard form submission handles it via POST /cart/add
      });
    }

    bindFormSubmit(orderForm);
    bindFormSubmit(heroForm);
  }

  // 5. In-Page Smooth Scroll Anchors
  function initSmoothAnchors() {
    var anchors = document.querySelectorAll('a[href^="#huna-offer"]');
    anchors.forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var target = document.getElementById('huna-offer');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var mainBtn = target.querySelector('[data-huna-action="add-to-cart"]');
          if (mainBtn) {
            setTimeout(function () {
              mainBtn.focus();
            }, 400);
          }
        }
      });
    });
  }

  // 3.5. Two-Option Offer Selector (1 Set vs 2 Sets)
  function initTierSwitcher() {
    var radios = document.querySelectorAll('input[name="huna-tier-choice"]');
    var qtyInput = document.getElementById('huna-lp-qty-input');
    var ctaText = document.getElementById('huna-lp-cta-text');
    var stickyPrice = document.getElementById('huna-lp-sticky-price');
    var whatsappCta = document.getElementById('huna-lp-whatsapp-cta');
    var orderCta = document.getElementById('huna-lp-order-cta');
    if (!radios.length || !qtyInput) return;

    var unitPriceMinor = orderCta && orderCta.getAttribute('data-unit-price') ? parseInt(orderCta.getAttribute('data-unit-price'), 10) : 215000;

    function formatMoneyMinor(minor) {
      var rupees = (minor / 100).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return 'Rs.' + rupees;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        var qty = parseInt(radio.value, 10) || 1;
        qtyInput.value = qty;

        // Toggle is-selected class on tier labels
        radios.forEach(function (r) {
          var label = r.closest('.huna-lp-tier');
          if (label) {
            label.classList.toggle('is-selected', r.checked);
          }
        });

        var totalPriceMinor = unitPriceMinor * qty;
        var formattedTotal = formatMoneyMinor(totalPriceMinor);

        if (ctaText) {
          if (qty === 1) {
            ctaText.textContent = 'Order now — ' + formattedTotal;
          } else {
            ctaText.textContent = 'Order ' + qty + ' sets — ' + formattedTotal;
          }
        }

        if (stickyPrice) {
          if (qty === 1) {
            stickyPrice.textContent = formattedTotal;
          } else {
            stickyPrice.textContent = formattedTotal + ' (' + qty + ' sets)';
          }
        }

        if (whatsappCta) {
          var setsLabel = qty === 1 ? '1 HUNA 4-in-1 Eyewear System' : qty + ' HUNA 4-in-1 Eyewear Systems';
          var waMsg = 'Hi HUNA, I would like to order ' + setsLabel + ' (' + formattedTotal + ') via Cash on Delivery. Please confirm delivery to my city.';
          whatsappCta.href = 'https://wa.me/923703618295?text=' + encodeURIComponent(waMsg);
        }
      });
    });
  }

  // 6. Accessible Trust Strip Marquee Pause/Play Control (Native Sync + ARIA)
  function initTrustMarquee() {
    var trustSection = document.getElementById('huna-lp-trust');
    var checkbox = document.getElementById('huna-trust-pause-toggle');
    var toggleBtn = document.getElementById('huna-trust-toggle-btn');
    var statusText = document.getElementById('huna-trust-toggle-status');
    if (!trustSection || !toggleBtn) return;

    function syncState(isPaused) {
      if (checkbox) {
        checkbox.checked = isPaused;
      }
      trustSection.classList.toggle('is-paused', isPaused);
      toggleBtn.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      var label = isPaused ? 'Play trust signals animation' : 'Pause trust signals animation';
      toggleBtn.setAttribute('aria-label', label);
      if (checkbox) {
        checkbox.setAttribute('aria-label', label);
      }
      toggleBtn.setAttribute('title', isPaused ? 'Play animation' : 'Pause animation');
      if (statusText) {
        statusText.textContent = label;
      }
    }

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        syncState(checkbox.checked);
      });
    }

    toggleBtn.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        var newState = !trustSection.classList.contains('is-paused');
        syncState(newState);
      }
    });
  }

  // DOMContentLoaded bootstrapper
  function initAll() {
    initLensSwitcher();
    initStickyBar();
    initTierSwitcher();
    initPurchaseAction();
    initSmoothAnchors();
    initTrustMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

